// OwnerListButton.jsx
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import ExportIcon from 'mdi-react/FormatListBulletedSquareIcon';
import { withStyles } from "@material-ui/core/styles";
import { isMobile } from "react-device-detect";

import DataExportCore from './DataExportCore'; // Import the new core component
import OwnerExportForm from './OwnerExportForm'; // Specific form for Owner Export
import { maxDownload, coreTranslate } from './../payment/plans.js';
import { _formatNumber } from '../../../shared/helpers/utils';

// Removed: Col, Container, Row, Modal, ButtonToolbar, Fab, EmailOutlineIcon, ShareIcon, PhoneIcon, LocationIcon, InfoIcon, CloseIcon, HelpIcon, ContactIcon, LockIcon, AddListIcon
// Removed: ExpandMoreIcon, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails
// Removed: SnackBar, FormGroup, FormControlLabel, Checkbox, Publisher, TrialSubscribe
// Removed: subscriptionPlans, dataExportCreditMap, coreTranslate, calculateCredits, translateCreditToDollars, costPerCredit, maxDownload, DataCreditUsageProgress
// Removed: all utility and API helper imports (they are now in DataExportCore)

const styles = {
	fab: {
		fontWeight: 400,
		background: "#780F9E",
		width: 240,
		"&.Mui-disabled": {
			color: "#F5F7FA",
			background: "#DBE0E8 !important",
		},
		"&:hover": {
			background: "#9600BF",
		},
	},
};

class OwnerListButton extends React.Component {
	static propTypes = {
		t: PropTypes.func.isRequired,
		user: PropTypes.object.isRequired,
		formValues: PropTypes.object, // From redux-form (if used by OwnerExportForm)
		core_name: PropTypes.string,
		q: PropTypes.string,
		fq: PropTypes.string,
		fl: PropTypes.string,
		sort: PropTypes.string,
		title: PropTypes.string,
		description: PropTypes.string,
		export_name: PropTypes.string,
		floatButton: PropTypes.bool,
		exportCount: PropTypes.number,
		fetchInProgress: PropTypes.bool,
		classes: PropTypes.object.isRequired, // Injected by withStyles
	};

	// Local state for form values, as OwnerExportForm seems to manage its own state
	state = {
		formValues: {
			exportName: this.props.export_name || "My Owner Outreach List",
			formatType: 'default'
		}
	};

	setFormValues = (values) => {
		this.setState({ formValues: values });
	};


	renderButton = ({ onClick }) => {
		const { title, floatButton, exportCount, core_name, user, fetchInProgress, classes, t } = this.props;
		const maxAllowed = maxDownload(core_name, user);

		if (floatButton) {
			return (
				<div style={{ position: 'fixed', bottom: 90, right: 100, zIndex: 999 }}>
					<Tooltip title={t('Export Mailing Address')}>
						<Fab
							variant="extended"
							size="medium"
							color="secondary"
							aria-label="add"
							style={{ fontWeight: 400, background: '#780F9E' }}
							onClick={onClick}
							disabled={!exportCount || fetchInProgress}
							className={classes.fab}
						>
							<ExportIcon style={{ marginRight: 5 }} /> Export Mailing Address
						</Fab>
					</Tooltip>
				</div>
			);
		} else {
			return (
				<Tooltip title={title ? title : t('Export Mailing Address')}>
					<Button
						onClick={onClick}
						variant="contained"
						color="secondary"
						className="buyersList__secondary-button"
						startIcon={!isMobile && <ExportIcon />}
						style={{ minWidth: isMobile ? 50 : 150 }}
					>
						{isMobile ? t("Mailing") : t("Mailing Address")}
					</Button>
				</Tooltip>
			);
		}
	};

	render() {
		const { user, core_name, q, fq, fl, sort, title, description, exportCount, fetchInProgress } = this.props;
		const { formValues } = this.state; // Use local state for form values

		return (
			<DataExportCore
				user={user}
				core_name={core_name || "we3-properties"} // Default core_name if not provided
				q={q}
				fq={fq}
				fl={fl}
				sort={sort}
				title={title || 'Request Owner List Export'}
				description={description}
				ExportFormComponent={OwnerExportForm}
				defaultExportName={this.props.export_name || "My Owner Outreach List"}
				exportType="owner" // Specifies this is an owner list export
				renderButton={this.renderButton}
				exportCount={exportCount}
				fetchInProgress={fetchInProgress}
				formValues={formValues} // Pass local formValues state
				setFormValues={this.setFormValues} // Pass updater for local formValues state
			/>
		);
	}
}

function mapStateToProps(state) {
	// No need to get formValues from redux-form here as OwnerExportForm manages its own state
	return {
		user: state.user,
	};
}

export default connect(mapStateToProps)(withTranslation('common')(withStyles(styles)(OwnerListButton)));

